import React, {Component} from 'react';
import _ from 'lodash';
import { formattedMoney } from '../../helpers/functions';
import { CURRENCY } from '../../helpers/variables';
import {
    DEFAULT,
    LOCALE_UK,
    PREMIUM_SETTINGS_COMMENTS_TEST_ID,
    PREMIUM_SETTINGS_ENDORSEMENTS_TEST_ID,
    PREMIUM_SETTINGS_LOI_TEST_ID,
    PREMIUM_SETTINGS_NOTES_TEST_ID,
    PREMIUM_SETTINGS_TABLE_TEST_ID,
    PS_TYPE_PERCENTAGE,
    QUATERNARY,
    RIGHT,
    PREMIUM_TYPE,
    PREMIUM_SETTINGS_COVERAGE_TEST_ID,
    PREMIUM_SETTINGS_DEDUCTIBLE_TEST_ID,
} from '../../helpers/constants';
import { calculateGroupColumns, calculateVerticalHeaders, calculateOuterVerticalHeaders, handlePremiumSettingsTableData} from  '../../helpers/premiumSettingsFunctions';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import { readonlyPremiumSettingsTableColumns } from '../../helpers/utilFunctions';
import { Button, List } from 'arag-ui-lib';
import SharedStep6 from './WizardSteps/sharedStep6';


class PremiumSettingsCombinationTable extends Component {

	constructor(props){
		super(props);
	}

    //function that calculates the damage band label
	getDamageBandName = (damageBand) => {
		let damages = [...this.props.allPossibleDamages.damages];
		if (damageBand.length === damages.length) {
			return CONTENT_STRINGS.UNLIMITED
		}
		else {
			if (_.last(damageBand).highValue === 0) {
				return `${CONTENT_STRINGS.OVER} ` + formattedMoney(damageBand[0].lowValue - 1, CURRENCY, 0);
			}
			else {
				return formattedMoney(damageBand[0].lowValue, CURRENCY, 0) + ' - ' + formattedMoney(_.last(damageBand).highValue, CURRENCY, 0);
			}
		}
	};

	getDamageBands = (item) => {
		let dmgBands=[];
		let dmgs = [];
		let allSubSettings = this.props.isPercentagePremium ? item.percentagePremiumSubSettings : item.premiumSubSettings;
		// Use only contingent entries to avoid duplicating damage bands when both types coexist.
		const contingentOnly = allSubSettings.filter(s => s.premiumType !== PREMIUM_TYPE.NON_CONTINGENT.key);
		let subSettings = contingentOnly.length > 0 ? contingentOnly : allSubSettings;
		let firstStage = subSettings[0].stageId;
		_.forEach(subSettings, (data, index) => {
			if(data.stageId === firstStage ) {
				let dam = [];
				_.forEach(data.damages, damage => {
					dam.push(_.find(this.props.allPossibleDamages.damages, item => {
						return item.id === damage.id
					}))
				});
				dmgs.push(...dam);
				if (dmgs.length <= this.props.allPossibleDamages.damages.length)
					dmgBands.push(dam)
			}
		});
		return dmgBands;
	};

	//function that calculated the table header data
	getTableHeaderData = (item) => {
		let dmgBands=this.getDamageBands(item);
		let headerData = [];
		_.forEach(dmgBands, band => {
			headerData.push({
				width: '188px',
				label: this.getDamageBandName(band)
			})
		});
		return headerData
	};


	//function that calculated the table header data
	getSelectedCaseStages = (item) => {
		let contingentStages = [];
		let nonContingentStages = [];
		let subSettings = this.props.isPercentagePremium ? item.percentagePremiumSubSettings : item.premiumSubSettings;
		_.forEach(subSettings, (data) => {
			const stage = { id: data.stageId, name: data.stageName, sortOrder: data.stageSortOrder };
			if (data.premiumType === PREMIUM_TYPE.NON_CONTINGENT.key) {
				if (!nonContingentStages.find(cs => cs.id === data.stageId)) {
					nonContingentStages.push(stage);
				}
			} else {
				if (!contingentStages.find(cs => cs.id === data.stageId)) {
					contingentStages.push(stage);
				}
			}
		});
		return { contingentStages, nonContingentStages };
	};

	//function that constructs the table data object
	getTableDataObj = (data) => {
		let tData = [];
		let subSettings = this.props.isPercentagePremium ? data.percentagePremiumSubSettings : data.premiumSubSettings;
		_.forEach(subSettings, subSetting => {
			let tmp = [];
			_.forEach(subSetting.premiumSubSettingCommissions, item => {
				tmp.push({
                    lawsysName: item.lawsysName,
                    lawsysId: item.lawsysId,
                    aragProvider: item.aragProvider,
                    commission: item.commission ? item.commission.toString() : '',
                    commissionPercentage: item.commissionPercentage.toString()
                })
            });
            const isNonContingent = subSetting.premiumType === PREMIUM_TYPE.NON_CONTINGENT.key;
            tData.push({
                stageId: subSetting.stageId,
                stageName: subSetting.stageName,
                stageSortOrder: subSetting.stageSortOrder,
                premium: subSetting.premium ? subSetting.premium.toString() : '',
                recoverable: subSetting.recoverable ? subSetting.recoverable.toString() : '',
                nonRecoverable: subSetting.nonRecoverable ? subSetting.nonRecoverable.toString() : '',
                underwriterRate: subSetting.underwriterRate ?subSetting.underwriterRate.toString() : '',
                underwriterRatePercentage: subSetting.underwriterRatePercentage ? subSetting.underwriterRatePercentage.toString() : '',
                recoverableRatePercentage: subSetting.recoverableRatePercentage ? subSetting.recoverableRatePercentage.toString() : '',
                premiumSubSettingCommissions: tmp,
                damages: subSetting.damages,
                premiumType: subSetting.premiumType,
                isNonContingent
            })
        });
        tData = _.sortBy(tData, 'stageSortOrder');
        return tData;
    };
    //function that find solicitor by id
    getSolicitor = (solicitorId) => {
        return _.find(this.props.lawsysFirms.lawsysFirms, item => {
            return item.id === solicitorId ;
        })
    };
    render() {
        return (
            <div className="row">
                <div className="col-sm-12 ">
                    <List
                        id={"sortable"}
                        variant={"toggle"}
                        items={
                            this.props.data.map((item, index) => {
                                const headerData = this.getTableHeaderData(item);
                                // GPL AC1/AC4 - this list renders saved Premium Settings, so it must honour the same
                                // Underwriter Rate/Amount lock as the wizard and Application Premium Settings do.
                                // Without the last argument the flag defaults to false and a Green/LEI group's rows
                                // would show a non-zero legacy value here while every other surface shows zero.
                                const columns = readonlyPremiumSettingsTableColumns(headerData, this.props.isPercentagePremium, this.props.showTable, this.props.isApplicationPremium, undefined, undefined, !!item.isGplSolicitorGroup);
                                const { contingentStages, nonContingentStages } = this.getSelectedCaseStages(item);
                                const verticalHeaders = calculateVerticalHeaders(contingentStages, nonContingentStages);
                                const outerVerticalHeaders = this.props.showNonContingentToggle ? calculateOuterVerticalHeaders(contingentStages, nonContingentStages) : null;
                                const groups = calculateGroupColumns(columns);
                                const toggleHeading = new Date(item.validFrom).toLocaleDateString(LOCALE_UK) + (item.validUntil ? (' - ' + new Date(item.validUntil).toLocaleDateString(LOCALE_UK)) : '')
                                const selectedCaseType = this.props.caseTypesRecords.find(ct => ct.id === item.caseTypeId);
                                const data = handlePremiumSettingsTableData(this.getTableDataObj(item), selectedCaseType, this.props.isPercentagePremium, this.props.showTable, this.props.isApplicationPremium);
                                return {
                                    id: item.id,
                                    className: `refSettingsListItem`,
                                    toggleHeading: toggleHeading,
                                    linkItemTestId:`premium-settings-setting-${index}-edit`,
                                    content: (
                                        <>
                                            <div>
                                                <div className='btn-wrapper-forForms '>
                                                    <Button 
                                                        onClick={() => {
                                                            if (this.props.psType === DEFAULT) {
                                                                this.props.changeNewPremiumStoreSettings('selectedSolicitorGroup', '');
                                                                this.props.changeNewPremiumStoreSettings('selectedWorksource', '');
                                                            }
                                                            this.props.push('premium-settings/edit-premium-settings/' + item.id)
                                                        }}
                                                        variant={QUATERNARY}
                                                        label={CONTENT_STRINGS.EDIT}
                                                        arrowDirection={RIGHT}
                                                        buttonTestId={`premium-settings-setting-${index}-edit`}
                                                    />
                                                </div>
                                                <form className="form-horizontal">
                                                    <SharedStep6
                                                        successMsg={''}
                                                        badResponseMsg={''}
                                                        posting={item.posting}
                                                        limitOfIndemnity={item.limitOfIndemnity}
                                                        recoverableRatePercentage={item.recoverableRatePercentage}
                                                        validFrom={item.validFrom}
                                                        validUntil={item.validUntil}
                                                        notes={item.notes}
                                                        endorsements={item.endorsements}
                                                        comments={item.comments}
                                                        currentStep={6}
                                                        displayedCoverageType={item.coverageOptionName}
                                                        displayedDeductible={item.displayedDeductible}
                                                        displayedEndorsement={item.displayedEndorsement}
                                                        isApplicationPremium={this.props.isApplicationPremium}
                                                        isPercentagePremium={this.props.isPercentagePremium}
                                                        topHeader={this.props.topHeader}
                                                        groups={groups}
                                                        columns={columns}
                                                        data={data}
                                                        verticalHeaders={verticalHeaders}
                                                        outerVerticalHeaders={outerVerticalHeaders}
                                                        patching={item.patching}
                                                        appPremiumSettingsIndicator={item.appPremiumSettingsIndicator}
                                                        showTable={this.props.showTable}
                                                        stepMessages={this.props.stepMessages}
                                                        loiTestId={PREMIUM_SETTINGS_LOI_TEST_ID}
                                                        notesTestId={PREMIUM_SETTINGS_NOTES_TEST_ID}
                                                        commentsTestId={PREMIUM_SETTINGS_COMMENTS_TEST_ID}
                                                        endorsementsTestId={PREMIUM_SETTINGS_ENDORSEMENTS_TEST_ID}
                                                        tableTestId={PREMIUM_SETTINGS_TABLE_TEST_ID}
                                                        validFromLabel={toggleHeading}
                                                        coverageTestId={PREMIUM_SETTINGS_COVERAGE_TEST_ID}
                                                        deductiblesTestId={PREMIUM_SETTINGS_DEDUCTIBLE_TEST_ID}
                                                    />
                                                </form>
                                            </div>
                                        </>
                                    )
                                };
                            }
                        )}
                    />
                </div>
            </div>
        )
    }
};

export default PremiumSettingsCombinationTable;
